'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { getEmailSubscriptions, createGetEmailSubscriptions } from 'reference-resolvers/api/EmailSubscriptionAPI';
export const createEmailSubscriptionReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.EMAIL_SUBSCRIPTIONS,
  createFetchData: createGetEmailSubscriptions,
  fetchData: getEmailSubscriptions
}, options));
export default createEmailSubscriptionReferenceResolver();